import * as Long from "long";
import { selectBuildingStageInfo } from "../../../../selectors/selectExistingBuildingInfo";
import { selectNotEnoughResourcesMissingResources } from "../../../../selectors/selectNotEnoughResources";
export var checkBuildingPurchaseHasEnoughResourceStandard = function (path) { return function (action, state$) {
    var building = action.building, premium = action.premium;
    var initialStageInfo = selectBuildingStageInfo(building, 0);
    if (!premium && initialStageInfo && initialStageInfo.standard) {
        var standardCosts = initialStageInfo.standard.cost.map(function (cost) { return ({
            amount: Long.fromValue(cost.amount),
            typeId: cost.resourceId,
        }); });
        var missingResources = selectNotEnoughResourcesMissingResources(state$.value, standardCosts);
        if (missingResources.length > 0) {
            return path;
        }
    }
    return undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/checks/checkBuildingPurchaseHasEnoughResourceStandard.ts
// module id = 2062
// module chunks = 3